import emitGlobalFileEventWithData from "./file-upload-events.js";
export default function makeFileUploader({ file, path, id }) {
    const BUNNY_KEY = '5846b93d-fd17-4358-8a47a6b55a34-8211-4af1';
    const DEST_PATH = 'https://ny.storage.bunnycdn.com/tbn-storage/';
    const CDN_STPRAGE = 'https://thebrooklynnomads.b-cdn.net/';
    return Object.freeze({
        upload
    });
    async function upload() {
        return await new Promise((resolve, reject) => {
            const req = new XMLHttpRequest();
            req.open("PUT", `${DEST_PATH}${path}`, true);
            req.setRequestHeader('Content-Type', 'application/octet-stream');
            req.setRequestHeader('AccessKey', BUNNY_KEY);
            req.upload.onprogress = (e) => {
                const size = file.size;
                if (e.loaded <= size) {
                    const perc = Math.round(e.loaded / size * 100);
                    emitGlobalFileEventWithData('progress-received', { id, perc });
                }
            };
            req.onload = (e) => {
                if (req.status === 0 || (req.status >= 200 && req.status < 400)) {
                    return resolve(`${CDN_STPRAGE}${path}`);
                }
                else {
                    return reject(new Error(req.responseText));
                }
            };
            req.onerror = (error) => { console.error(error); return reject(new Error(error)); };
            req.send(file);
        });
    }
}
